export default __webpack_public_path__ + "static/media/H1007.3.cd59597c.mp3";